"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSendTasks = void 0;
const index_1 = require("../../../../../Errors/index");
const index_2 = require("../../../../Model/index");
const TypeFactory_1 = require("../../../TypeFactory");
const ActivityFactory_1 = require("./ActivityFactory");
const ExtensionPropertyParser_1 = require("./ExtensionPropertyParser");
function parseSendTasks(processData, eventDefinitions) {
    const sendTasksRaw = (0, TypeFactory_1.getModelPropertyAsArray)(processData, index_2.BpmnTags.TaskElement.SendTask);
    const noSendTasksFound = !((sendTasksRaw === null || sendTasksRaw === void 0 ? void 0 : sendTasksRaw.length) > 0);
    if (noSendTasksFound) {
        return [];
    }
    const sendTasks = sendTasksRaw.map((sendTaskRaw) => {
        const flowNodeId = sendTaskRaw.id;
        try {
            return parseSendTask(sendTaskRaw, eventDefinitions);
        }
        catch (error) {
            error.additionalInformation = {
                ...error.additionalInformation,
                flowNodeId: flowNodeId,
            };
            throw error;
        }
    });
    return sendTasks;
}
exports.parseSendTasks = parseSendTasks;
function parseSendTask(sendTaskRaw, eventDefinitions) {
    var _a, _b;
    const sendTask = (0, ActivityFactory_1.createActivityInstance)(sendTaskRaw, index_2.Model.Activities.SendTask);
    if (!sendTaskRaw.messageRef) {
        throw new index_1.UnprocessableEntityError(`SendTask \`${sendTaskRaw.id}\` does not have a messageRef!`);
    }
    sendTask.messageEventDefinition = eventDefinitions.find((entry) => entry.id === sendTaskRaw.messageRef);
    const configuredRetryInterval = (_a = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('retryInvervalInMs', sendTask.extensionElements.camundaExtensionProperties)) === null || _a === void 0 ? void 0 : _a.value;
    const configuredMaxRetries = (_b = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('maxRetries', sendTask.extensionElements.camundaExtensionProperties)) === null || _b === void 0 ? void 0 : _b.value;
    sendTask.retryIntervalInMs = configuredRetryInterval ? parseInt(configuredRetryInterval) : 500;
    sendTask.maxRetries = configuredMaxRetries ? parseInt(configuredMaxRetries) : -1;
    return sendTask;
}
//# sourceMappingURL=SendTaskParser.js.map